import React from 'react';
import { Parallax } from "react-parallax";
import { Link } from 'react-router-dom';


const Download = () => {
    return(
        <div className="container">
            <div className="row position-relative">
                <div className="col-lg-12">
                    <Parallax className="padding60 sm-padding40" bgImage="./img/background/2.webp" strength={400}> 
                        <div className="col-lg-6">
                            <div className="subtitle wow fadeInUp mb-3">Download coming soon</div>
                            <h2 className="wow fadeInUp" data-wow-delay=".2s">Manage your novels from your mobile device</h2>
                            <p>The novelfy app is under development for android and IOS.</p>                            
                            <Link to="/"><img width="180" height="100" src="../../img/misc/download-appstore.webp" className="img-fluid mb-sm-20" alt="download"/></Link>&nbsp;
                            <Link to="/"><img width="180" height="100" src="../../img/misc/download-playstore.webp" className="img-fluid mb-sm-20" alt="download"/></Link>
                        </div>
                    </Parallax>
                    <img width="700" height="550" src="./img/misc/man-with-phone.webp" className="max-content sm-hide position-absolute bottom-0 end-0"  alt=""/>
                </div>
            </div>
        </div>
    );
}

export default Download;